import React, { useState, useEffect } from 'react';
import './App.css';
import fonImage from './assets/fon.webp'; // Импортируем изображение
import { ReactComponent as Icon } from './assets/Portal ua logo.svg'; // Импортируем SVG как компонент
import { ReactComponent as Icon1 } from './assets/Group.svg'; // Импортируем SVG как компонент
import { ReactComponent as Icon2 } from './assets/Group-1.svg'; // Импортируем SVG как компонент
import { ReactComponent as Icon3 } from './assets/Group-3.svg'; // Импортируем SVG как компонент

function App() {
    // Состояние для отслеживания ширины экрана
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Обновление состояния ширины экрана при изменении размера окна
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Очистка события при размонтировании компонента
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Размер иконок в зависимости от ширины экрана
    const iconSize = windowWidth <= 768 ? 55 : 40;

    return (
        <div className="App">
            <div className="background-image" style={{ backgroundImage: `url(${fonImage})` }}>
                <div className="content">
                    <div className="text-container">
                        <span className="coming-soon">Coming soon</span>
                        <Icon className="central-icon" width="100%" height="auto" />
                        <span className="life-canada">Space for Your Life in Canada</span>
                    </div>
                </div>
            </div>

            <div className="icons-container">
                <a href="https://www.facebook.com/PortalUA.ca" target="_blank" rel="noopener noreferrer">
                    <div className="icon" style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                        <Icon1 width={iconSize} height={iconSize} />
                    </div>
                </a>
                <a href="https://www.instagram.com/portalua.ca" target="_blank" rel="noopener noreferrer">
                    <div className="icon" style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                        <Icon2 width={iconSize} height={iconSize} />
                    </div>
                </a>
                <a href="https://t.me/PortalUa_ca" target="_blank" rel="noopener noreferrer">
                    <div className="icon" style={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                        <Icon3 width={iconSize} height={iconSize} />
                    </div>
                </a>
            </div>
        </div>
    );
}

export default App;
